'use strict';

module.exports = /*@ngInject*/
function I18nService(
    ConfigHTTPService,
    DateService,
    I18nConfig,
    ProfileHTTPService,
    RouterService
) {
    var model = {
        config: {
            site: {
                id: ''
            }
        },
        preferredLanguage: ''
    };
    var queryParams = RouterService.getQueryParams();

    ConfigHTTPService.getConfig()
        .then(function onConfigRes(res) {
            model.config = res;
        });

    ConfigHTTPService.getPreferredLanguage()
        .then((preferredLanguage) => {
            model.preferredLanguage = preferredLanguage;
        });

    return {
        /**
         * Convert Unix timestamp into a time string using
         * EU-formatting with an optional delimiter. Default delimiter
         * is a period. Using the default delimiter, the returned
         * time string takes the form of DD.MM.YYYY if the context is EU,
         * otherwise it will take the form of MM.DD.YYYY.
         * @param  {Number} unixTimestamp Unix timestamp
         * @param  {String} [delimiter]   An optional delimiting character e.g. '-' or '.'
         * @return {String}               Formatted time string
         */
        getDateString: function(unixTimestamp, delimiter) {
            if (this.isEU()) {
                return this.getEUDateString(unixTimestamp, delimiter);
            }

            return this.getUSDateString(unixTimestamp, delimiter);
        },

        /**
         * Convert Unix timestamp into a EU time string using
         * with an optional delimiter. Default delimiter
         * is a period.
         * @param  {String} [delimiter]   An optional delimiting character e.g. '-' or '.'
         * @return {String}               Formatted EU time string
         */
        getEUDateString: function(unixTimestamp, delimiter) {
            var date = DateService.getDateValues(unixTimestamp);

            delimiter = delimiter || '.';

            return date.day + delimiter + date.month + delimiter + date.year;
        },

        /**
         * Convert Unix timestamp into a US time string using
         * with an optional delimiter. Default delimiter
         * is a period.
         * @param  {String} [delimiter]   An optional delimiting character e.g. '-' or '.'
         * @return {String}               Formatted US time string
         */
        getUSDateString: function(unixTimestamp, delimiter) {
            var date = DateService.getDateValues(unixTimestamp);

            delimiter = delimiter || '.';

            return date.month + delimiter + date.day + delimiter + date.year;
        },

        /**
         * Is this the DE site?
         * @return {Boolean} True, if this is the DE site; false, otherwise.
         */
        isDE: function() {
            return model.config.siteId === I18nConfig.site.de;
        },

        /**
         * Is this the EU site?
         * @return {Boolean} True, if this is the EU site; false, otherwise.
         */
        isEU: function() {
            return model.config.siteId === I18nConfig.site.eu;
        },

        /**
         * Is this the FRCA site?
         * @return {Boolean} True, if this is the FRCA site; false, otherwise.
         */
        isFRCA: function() {
            return  queryParams.language === I18nConfig.language.frca ||
                    model.preferredLanguage === I18nConfig.language.frca;
        },

        /**
         * Is this the US site?
         * @return {Boolean} True, if this is the US site; false, otherwise.
         */
        isUS: function() {
            // TODO: FRCA has the same site id, should check the negate of isFRCA to
            // exclude FRCA
            return model.config.siteId === I18nConfig.site.us;
        }
    };
};
